document.addEventListener('DOMContentLoaded', () => {
  const imageWraps = document.querySelectorAll('.article-img-loading');

  imageWraps.forEach((wrap) => {
    const img = wrap.querySelector('img');

    const closeLoading = () => {
      wrap.classList.add('is-loaded');
    };

    // 没有图片或图片地址为空时，不显示加载动画。
    if (!img || (!img.getAttribute('src')?.trim() && !img.getAttribute('srcset')?.trim())) {
      closeLoading();
      return;
    }

    // 已完成的图片（包括加载失败的图片）直接关闭动画。
    if (img.complete) {
      closeLoading();
    } else {
      img.addEventListener('load', closeLoading, { once: true });
      img.addEventListener('error', closeLoading, { once: true });
    }
  });
});
